/**
 *
 * app selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { APP_KEY } from './app-constants';

const selectApp = (state) => state[APP_KEY] || {};

const selectClientSideReady = () =>
    createSelector(
        selectApp,
        (appState) => _get(appState, 'clientSideReady'),
    );

// eslint-disable-next-line import/prefer-default-export
export {
    selectApp,
    selectClientSideReady,
};
